// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/animation.less
// module id = 99
// module chunks = 0